import { useMemo } from "react"
import { useIdbState } from "../hooks/useIdbState"
import {
  ARTWORK_ASSET_STORAGE_KEY,
  ARTWORK_ASSET_STORAGE_VERSION,
  ArtworkAssetStoreSchema,
  EMPTY_ARTWORK_ASSET_STORE,
} from "../media/assets"
import { resolveArtworkUrl } from "../media/remote"
import type { CardArtwork, CardColor } from "../schemas"

type Props = {
  artwork?: CardArtwork
  primaryColor: CardColor
  name: string
  size?: "s" | "m" | "l"
  className?: string
}

export function ArtworkThumb({
  artwork,
  primaryColor,
  name,
  size = "m",
  className,
}: Props) {
  const [artworkAssets] = useIdbState(
    ARTWORK_ASSET_STORAGE_KEY,
    ArtworkAssetStoreSchema,
    {
      defaultValue: EMPTY_ARTWORK_ASSET_STORE,
      version: ARTWORK_ASSET_STORAGE_VERSION,
    },
  )

  const artworkUrl = useMemo(
    () => resolveArtworkUrl(artwork, artworkAssets, "thumb"),
    [artwork, artworkAssets],
  )

  return (
    <span
      aria-hidden="true"
      className={[
        "artwork-thumb",
        `artwork-thumb-${size}`,
        `artwork-thumb-${primaryColor}`,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {artworkUrl ? (
        <img alt="" className="artwork-thumb-image" src={artworkUrl} />
      ) : (
        <span className="artwork-thumb-fallback">{name.slice(0, 1)}</span>
      )}
    </span>
  )
}
